const hasReportView = (report) => {
  const getResponsesBySequence = responses => responses.reduce((accumulator, response) => {
    if(!response) {
      return accumulator
    }
    const keyedBySequence = { [response.sequence]: { ...response } };
    // Remove redundant
    delete keyedBySequence[response.sequence].sequence;
    return Object.assign(accumulator, keyedBySequence);
  }, {});

  return {
    getResponses() {
      return getResponsesBySequence(report.responses);
    },
    getReportView() {

      let allHeadersReport = report.layout.filter(element => element.type === 'header' || element.schema === 'datetime').length === report.layout.length;

      const elements = report.layout.reduce((accumulator, element, index) => {
        if (element.type === 'header' && report.layout.length > 1 && !allHeadersReport) {
          accumulator.push({...element})
          return accumulator;
        }
        const responses = getResponsesBySequence(report.responses);
        accumulator.push({
          ...element,
          ...responses[index],
        });
        return accumulator;
      }, []);
      const view = {
        ...report,
        elements,
      };
      // Remove redundant
      delete view.layout;
      delete view.responses;
      return view;
    },
  };
};

export default hasReportView;
